/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { css, cx } from "@panda/css";

import { Box, BoxProps } from "@panda/jsx";

export interface CosmosTableCellProps extends BoxProps {
	children: React.ReactNode;
}

const tableCellStyles = css({
	minHeight: "eds.dimension.56",
	padding: "eds.dimension.24",
});

/**
 * Expects to be used within a TableRow. If the same gridTemplateColumns is passed to TableHeader and TableRows,
 * each TableColumn will should align with TableCells below it.
 */

export const CosmosTableCell = ({ children, className, ...props }: CosmosTableCellProps): React.JSX.Element => {
	return (
		<Box
			gap={props.gap || "eds.dimension.16"}
			alignItems={props.alignItems || "flex-start"}
			alignSelf={props.alignSelf || "stretch"}
			{...props}
			className={cx("cosmos-table__cell", tableCellStyles, className)}
		>
			{children}
		</Box>
	);
};

CosmosTableCell.displayName = "CosmosTable.Cell";
